module.exports = __webpack_public_path__ + "static/media/DAL_Logo.46e5b068.png";